import { injectable } from 'inversify';
import { fetchAuthSession } from '@aws-amplify/auth';

import type {
  FetchReceipt,
  GetActivePayment,
  GetActiveSubscription,
  GetAllTransactions,
  GetPaymentDetails,
  GetSubscriptions,
  GetTransactions,
  UpdateSubscription,
} from '../../../../types/subscription';
import SubscriptionService from '../SubscriptionService';
import env from '../../../env';

@injectable()
export default class AWSStripeSubscriptionService extends SubscriptionService {
  constructor() {
    super();
  }

  getActiveSubscription: GetActiveSubscription = async ({ customerId }) => {
    const response = await this.getSubscriptions({ customerId });

    if (response.errors.length > 0) return null;

    return response.responseData.items[0];
  };

  getAllTransactions: GetAllTransactions = async ({ customerId }) => {
    const response = await this.getTransactions({ customerId });

    if (response.errors.length > 0) return null;

    return response.responseData.items;
  };

  getActivePayment: GetActivePayment = async ({ customerId }) => {
    const response = await this.getPaymentDetails({ customerId });

    if (response.errors.length > 0) return null;

    return response.responseData.paymentDetails.find((paymentDetails) => paymentDetails.active) || null;
  };

  getSubscriptions: GetSubscriptions = async () => {
    const user = await fetchAuthSession();
    const response = await fetch(`${env.APP_ACCOUNT_API_BASE_URL}/active-subscriptions`, {
      headers: { Authorization: `Bearer ${user.tokens?.idToken?.toString()}` },
    });
    const data = await response.json();

    return { responseData: { items: data.subscriptions }, errors: [] };
  };

  updateSubscription: UpdateSubscription = async () => {
    throw new Error('Not supported');
  };

  getPaymentDetails: GetPaymentDetails = async () => {
    return {
      responseData: { paymentDetails: [] },
      errors: [],
    };
  };

  getTransactions: GetTransactions = async () => {
    return { responseData: { items: [] }, errors: [] };
  };

  fetchReceipt: FetchReceipt = async () => {
    throw new Error('Not supported');
  };

  updateCardDetails: undefined;

  changeSubscription: undefined;
}
